// extracted by mini-css-extract-plugin
export default {"car-summary":"wlt-overview_car-summary__JKv+j","wlt-wrapper":"wlt-overview_wlt-wrapper__NiYtN"};